// components/Navbar/index.js

import React from "react";
import { Button } from "@mui/material";
import "./NavBar.css";
import { useIsAuthenticated } from "@azure/msal-react";
import useSignOut from "./SignOut";

const Navbar = () => {
  const isAuthenticated = useIsAuthenticated();
  const handleSignOut = useSignOut();
  return (
    <nav className="navbar">
      <div className="navbar-left">
        <img
          className="navbar-logo"
          src={
            "https://gmenergy.gm.com/content/dam/gmenergy/na/us/en/primary-navigation/gmenergy/01-images/logo-gmenergy-home-darkbg.svg"
          }
          alt="GM Energy Logo"
        />
      </div>
      <div className="navbar-right">
         {isAuthenticated && (<Button
          className="logout-button"
          onClick={handleSignOut}
        >
          Logout
        </Button>)}
      </div>
    </nav>
  );
};

export default Navbar;